module.exports = __webpack_public_path__ + "static/img/planRight6.1300cbe7.png";